import {
  type Action, type AsyncStateObject,
  type CompleteSessionResponse
} from '../../../interfaces'
import { APP_ACTION_STATUS, COMMON_ACTIONS, SESSION_ACTIONS } from '../../../utils/constants'

const INITIAL_STATE: AsyncStateObject<CompleteSessionResponse> = {
  data: {
    message: ''
  },
  isLoading: false,
  status: APP_ACTION_STATUS.INITIAL,
  error: undefined
}

const startAndCompleteReducer = (state = INITIAL_STATE, action: Action<CompleteSessionResponse>) => {
  switch (action.type) {
    case SESSION_ACTIONS.UPDATE_SESSION_STATUS_BY_ID + COMMON_ACTIONS.REQUEST:
      return {
        ...state,
        isLoading: true,
        status: APP_ACTION_STATUS.LOADING,
        error: undefined
      }
    case SESSION_ACTIONS.UPDATE_SESSION_STATUS_BY_ID + COMMON_ACTIONS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: APP_ACTION_STATUS.SUCCESS,
        data: action.data
      }
    case SESSION_ACTIONS.UPDATE_SESSION_STATUS_BY_ID + COMMON_ACTIONS.ERROR:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        status: APP_ACTION_STATUS.ERROR,
        error: action.error
      }
    case SESSION_ACTIONS.UPDATE_SESSION_STATUS_BY_ID + COMMON_ACTIONS.CLEAR:
      return INITIAL_STATE
    default:
      return state
  }
}
export default startAndCompleteReducer
